import keyConverter from "services/key-converter";
import { setState } from "actions";
import { createAlert } from "actions/alerts";
import { closeModal } from "actions/modal";
import Immutable from "immutable";
import {
  getNormalOperatingDays,
  getSpecialOperatingDays,
  convertSchedulesToPayload
} from "services/scheduleFormatConverter";

export const createScheduleModalAction = () => ({
  type: "CREATE_SETTINGS_SCHEDULE_MODAL"
});

export const setScheduleModalAction = payload => ({
  type: "SET_SETTINGS_SCHEDULE_MODAL",
  payload
});

export const handleUpdateScheduleModalAction = payload => ({
  type: "UPDATE_SETTINGS_SCHEDULE_MODAL",
  payload
});

export const handleUpdateScheduleRowAction = payload => ({
  type: "UPDATE_SETTINGS_SCHEDULE_ROW",
  payload
});

export const handleAddScheduleRowAction = payload => ({
  type: "ADD_SETTINGS_SCHEDULE_ROW",
  payload
});

export const handleDeleteScheduleRowAction = payload => ({
  type: "DELETE_SETTINGS_SCHEDULE_ROW",
  payload
});

/**
 * @param {Object} payload
 * @returns {Function}
 */
export function showScheduleModalAction(payload) {
  return dispatch => dispatch(
    setState("MODAL", {
      isOpen: true,
      view: "SETTINGS_SCHEDULES_MODAL",
      modalProps: payload
    })
  );
}

/**
 * patch scheduled block schedules to Client
 * @param {Object} schedules
 * @param {String} action - "create" or "update" or "delete"
 * @returns {Object}
 */
export function patchScheduledBlockSchedules(schedules, action) {
  const data = keyConverter(schedules.toJS(), "underscore");
  let successMessage;

  switch (action) {
    case "create":
      successMessage = "Done! You can now use this new schedule inside a scheduled block.";
      break;
    default:
      successMessage = `Schedule was successfully ${action}d.`;
  }

  return {
    CALL_API: {
      method: "patch",
      endpoint: "/scheduled-block-schedules/",
      payload: { scheduled_block_schedules: data },
      types: [
        "PATCH_SCHEDULED_BLOCK_SCHEDULES_REQUEST",
        "PATCH_SCHEDULED_BLOCK_SCHEDULES_SUCCESS",
        "PATCH_SCHEDULED_BLOCK_SCHEDULES_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: 400
        },
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: successMessage,
            alertType: "success"
          }
        },
        {
          request: closeModal,
          fireOnStatus: "success"
        }
      ]
    }
  };
}

/**
 * delete a schedule
 * @param {Object} payload
 * @returns {Object}
 */
export const deleteSchedule = payload => (dispatch, getState) => {
  const state = getState();
  const { settingsScheduledBlockSchedules } = state;
  const schedules = convertSchedulesToPayload(settingsScheduledBlockSchedules)
    .update(
      items => items.filter(item => item.get("id") !== payload.scheduleId)
    );

  dispatch(patchScheduledBlockSchedules(schedules, "delete"));
};


/**
 *
 * @param {Object} response
 * @returns {Object}
 */
function handleGetScheduleReferences(response) {
  let responseScheduleReferences = response.response.data.response_schedule_references;

  if (responseScheduleReferences) {
    responseScheduleReferences = keyConverter(responseScheduleReferences);
  }

  const setModal = (caseProps) => {
    const baseProps = {
      responseScheduleReferences: Immutable.List(responseScheduleReferences),
      scheduleId: response.response.data.schedule_id
    };
    const modalProps = { ...baseProps, ...caseProps };

    return {
      type: "SET_MODAL",
      payload: {
        isOpen: true,
        view: "MODAL_WARNING",
        modalProps
      }
    };
  };

  if (responseScheduleReferences) {
    const caseProps = {
      title: "Schedule in Use",
      message: `This schedule is used in the following answer${responseScheduleReferences.length > 1 ? "s" : ""} and can't be deleted…`,
      buttons: [
        "cancel"
      ],
      type: "schedule",
      totalReferenceButtons: responseScheduleReferences.length
    };

    return setModal(caseProps);
  }

  const caseProps = {
    title: "Delete Schedule",
    message: "Are you sure you would like to delete this Schedule?",
    buttons: [
      "delete_schedule",
      "cancel"
    ],
    type: "delete"
  };

  return setModal(caseProps);
}

/**
 *
 * @param {String} scheduleId
 * @returns {Object}
 */
export function getScheduleReferences(scheduleId) {
  return {
    CALL_API: {
      method: "get",
      endpoint: `/scheduled_block_schedules/references/${scheduleId}`,
      types: [
        "GET_SCHEDULED_BLOCK_REFERENCES_REQUEST",
        "GET_SCHEDULED_BLOCK_REFERENCES_SUCCESS",
        "GET_SCHEDULED_BLOCK_REFERENCES_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: handleGetScheduleReferences,
          fireOnStatus: "success"
        },
        {
          request: handleGetScheduleReferences,
          fireOnStatus: 400
        }
      ]
    }
  };
}

/**
 * update current schedule or add a new schedule
 * @returns {Object}
 */
export function handleSaveScheduleModalAction() {
  return (dispatch, getState) => {
    const state = getState();
    const { settingsScheduledBlockSchedules, settingsScheduleModal, modal } = state;
    let schedules = convertSchedulesToPayload(settingsScheduledBlockSchedules) || Immutable.List();
    const action = modal.getIn(["modalProps", "newSchedule"]) ? "create" : "update";
    const scheduleIndex = modal.getIn(["modalProps", "scheduleIndex"]);

    const newSchedule = Immutable.Map({
      id: settingsScheduleModal.get("id"),
      name: settingsScheduleModal.get("name"),
      timezone: settingsScheduleModal.get("timezone"),
      normalOperatingDays: getNormalOperatingDays(settingsScheduleModal.get("normalOperatingDaysRows")),
      specialOperatingDays: getSpecialOperatingDays(settingsScheduleModal.get("specialOperatingDaysRows"))
    });

    if (action === "create") {
      schedules = schedules.update(allSchedules => allSchedules.push(newSchedule));
    } else {
      schedules = schedules.mergeIn([scheduleIndex], newSchedule);
    }

    dispatch(patchScheduledBlockSchedules(schedules, action));
  };
}
